<template>
    <div class="loading">
        <div class="loading-content">
            <span class="loading-bar"></span>
            Laddar...
        </div>
    </div>
</template>


<script>
export default {
    name: 'loadingSpinner',
    
    data() {
        return {

        }
    }
}
</script>

<style>
    /* Loading screen */
    .loading {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999;
    }

    .loading-bar {
        display: block;
        width: 30px;
        height: 30px;
        border: 4px solid blue;
        border-radius: 50%;
        border-top-color: blue;
        border-right-color: transparent;
        border-bottom-color: transparent;
        border-left-color: transparent;
        animation: spinLoader 1s infinite;
        margin-bottom: 10px;
    }

    @keyframes spinLoader {
        0% {transform: rotate(0deg)}
        100% {transform: rotate(359deg)}
    }
</style>



// WEBPACK FOOTER //
// src/components/LoadingSpinner.vue